import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class SignupCompletedEventTracking extends BaseEventTracking {
  /**
   * @var {string}
   */
  static eventName = SegmentEvent.SIGN_UP_COMPLETED;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  email;

  /**
   * @var {DateTime}
   */
  createdAt;

  /**
   * @param {AuthUser} authUser
   */
  constructor(authUser) {
    super();
    this.name = authUser.name;
    this.email = authUser.email;
    this.createdAt = authUser.createdAt;
  }
}
